import { SelectBase, SelectBaseProps } from "@compass/core";
import { ModelPropertyBase } from "generated/openApi";

export const Select = <T, Multiple extends boolean = false>(
  props: SelectBaseProps<T, Multiple> & {
    modelProperty?: ModelPropertyBase | undefined;
  }
) => {
  const { modelProperty, ...rest } = props;

  return <SelectBase label={modelProperty?.displayName} required={modelProperty?.required} {...rest} />;
};
